import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2630_23665)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M24 3.47v17.071C24 22.847 22.883 24 20.627 24H3.63c.838-.481 1.107-1.153 1.107-2.35V3.47C4.738 1.164 5.866 0 8.11 0h12.516C22.883 0 24 1.164 24 3.47M2.643 20.91c0 .818-.57 1.333-1.322 1.344C.57 22.254 0 21.728 0 20.91v-9.996C0 9.582.806 8.81 2.116 8.81h.527zm6.983-7.723c-.795 0-1.268.492-1.268 1.32v2.833c0 .817.473 1.31 1.268 1.31h2.686c.784 0 1.257-.493 1.257-1.31v-2.832c0-.829-.473-1.321-1.257-1.321zm6.08 4.03c-.386 0-.666.313-.666.705 0 .38.28.671.666.671h4.008c.376 0 .655-.29.655-.671 0-.392-.28-.706-.655-.706zm0-4.03c-.386 0-.666.302-.666.705 0 .38.28.671.666.671h4.008c.376 0 .655-.29.655-.671 0-.403-.28-.705-.655-.705zm-6.66-3.952c-.387 0-.677.302-.677.694 0 .38.29.683.677.683h10.668a.667.667 0 0 0 .666-.683c0-.392-.29-.694-.666-.694zm0-3.94a.66.66 0 0 0-.677.671c0 .392.29.706.677.706h10.668c.376 0 .666-.314.666-.706 0-.38-.29-.671-.666-.671z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2630_23665" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }